import React from "react";
import { SelectedFilterInfo, StandardFilterProps } from "web/types/feed-filters";
import { PairOfSelectsFilterSection } from "web/types/universal-filters";
import FeedsFiltersDropDown from "web/react/components/feeds-filters/feeds-filters-drop-down/feeds-filters-drop-down";
import styles from "./feeds-filters-pair-of-selects.css";

interface PairOfSelectsProps extends StandardFilterProps {
    section: PairOfSelectsFilterSection;
    selectedFilterInfo: SelectedFilterInfo;
}
export function FeedsFiltersPairOfSelects({ section, ...props }: PairOfSelectsProps): JSX.Element {
    return (
        <div className={styles.dropDowns}>
            <FeedsFiltersDropDown
                className={styles.dropDown}
                group={section.option_groups[0]}
                {...props}
            />
            <FeedsFiltersDropDown
                className={styles.dropDown}
                group={section.option_groups[1]}
                {...props}
            />
        </div>
    );
}
